import { fetchArray } from 'entity';
import Rodada from 'entity/Rodada';
import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../../../app/AppContext';
import { Box, Button, CircularProgress, Grid, Typography } from '@mui/material';

import _ from 'lodash'

// import logo from './logof.png'
import "./style.css"

import { useIsAdmin, useUserUid } from 'useAuth';
import CardRodada from 'entity/Rodada/components/CardRodada';
import { robustShare } from 'utils/shareUtils';
import { format } from 'date-fns';
const formatDate = (dateStr) => format(new Date(dateStr), "dd/MM, HH:mm");

export default function Home() {
    const [rodadas, setRodadas] = useState([])
    const [loading, setLoading] = useState(true)
    const navigate = useNavigate();
    const { useSetTitle } = useAppContext();

    const currentUserUID = useUserUid()
    const isAdmin = useIsAdmin()

    const compartilharRodada = async (rodada) => {
        const linkInscricao = `${window.location.origin}/inscrever-se?rodada=${rodada.uid}`;
        // const linkInscricao = `https://paeco-linkme.web.app/#/inscrever-se?rodada=${rodada.uid}`;

        let texto = `🎯 *${rodada.nome.toUpperCase()}*

${rodada.descricao}

📍 Local: ${rodada.local}
📅 Data: ${formatDate(rodada.dataInicio)} até ${formatDate(rodada.dataFinal)}

🔗 Link para inscrição: 
${linkInscricao}

💼 Participe desta oportunidade de negócios!`;

        // Adiciona contatos se disponíveis
        if (rodada.emailContato || rodada.telefoneContato) {
            texto += '\n\n📞 Contatos:';
            if (rodada.emailContato) {
                texto += `\n📧 Email: ${rodada.emailContato}`;
            }
            if (rodada.telefoneContato) {
                texto += `\n📱 WhatsApp: ${rodada.telefoneContato}`;
            }
        }

        // Usar o utilitário de compartilhamento robusto
        await robustShare({
            title: 'Rodada de Negócios',
            text: texto,
            url: linkInscricao,
            imageBase64: rodada.capa?.base64,
            imageName: `rodada-${rodada.nome}-capa.jpg`,
            askForImage: true,
            onSuccess: (method) => {
                console.log(`Compartilhamento bem-sucedido via ${method}`);
            },
            onError: (error, method) => {
                console.error(`Erro no compartilhamento via ${method}:`, error);
            }
        });
    };
    const loadOptions = useCallback(async () => {
        let resultRodada

        let startData = new Date().toISOString().split("T")[0] + "T00:00"

        // Carrega apenas uma vez.
        if (rodadas.length === 0) {
            let queryR = await Rodada.where("status", "==", "ATIVO")

            queryR = queryR.where("dataFinal", ">=", startData)
            resultRodada = await fetchArray(queryR.get())

            resultRodada.sort((a, b) => {
                const dataInicioA = new Date(a.dataInicio).getTime()
                const dataInicioB = new Date(b.dataInicio).getTime()
                return dataInicioA - dataInicioB
            })

            // Primeiro, define as rodadas
            setRodadas(resultRodada)
            setLoading(false)
        }
    }, [rodadas.length]);

    useEffect(() => {
        loadOptions();
    }, [loadOptions]);

    useSetTitle("RODADA DE NEGÓCIOS - INÍCIO")

    const rodadaFilter = rodadas
        .filter(rodada => {
            if (isAdmin) {
                return true
            }

            if (rodada.perfisAutorizado) {
                let uidList = Object.keys(rodada.perfisAutorizado)

                if (uidList.length) {
                    let foundUserUID = uidList.find(userUID => userUID === currentUserUID)

                    if (foundUserUID) {
                        let isAuthorised = _.get(rodada.perfisAutorizado, foundUserUID)

                        if (isAuthorised) {
                            return true
                        }
                    }
                }
            }
            return false
        })


    return (
        <Box sx={{ px: { xs: 1, md: 4 }, py: 4 }}>
            <Typography variant="h4" fontWeight={600} textAlign="center" gutterBottom>
                PRÓXIMAS RODADAS
            </Typography>

            <Grid container spacing={{ xs: 2, md: 4 }} justifyContent="center">
                {rodadaFilter.length === 0 && loading && (
                    <Box sx={{ width: '100%', textAlign: 'center', py: 4 }}>
                        <CircularProgress />
                    </Box>
                )}
                {!loading && rodadaFilter.length === 0 && (
                    <Box sx={{ width: '100%', textAlign: 'center', py: 4 }}>
                        <Typography variant="h6" color="text.secondary">
                            Não há rodadas disponíveis no momento.
                        </Typography>
                    </Box>
                )}

                {rodadaFilter
                    .filter(r => {
                        return (
                            // rodadas futuras OU que estão acontecendo
                            new Date(r.dataInicio) > new Date()
                            || (
                                new Date(r.dataInicio) <= new Date()
                                && new Date(r.dataFinal) >= new Date()
                            )
                        )
                    })
                    .map((r, index) => {
                        return <Grid item xs={12} md={6} lg={6} key={index}>
                            <CardRodada
                                key={index}
                                rodada={r}
                                showNumInscricoes
                                onCompartilhar={compartilharRodada}
                            >

                                <Button
                                    variant="contained"
                                    fullWidth
                                    onClick={() => (
                                        navigate("/painel-controle?rodada=" + r.uid)
                                    )}
                                    aria-label={`Painel ${r.nome}`}
                                >
                                    Abrir Painel
                                </Button>
                            </CardRodada>
                        </Grid>

                    })}
            </Grid>
        </Box>

    )
}
